import styled from 'styled-components';
import { InputProps } from '..';

type IVariantProp = {
  variant: InputProps['variant'];
};

export const InputContainer = styled.div<IVariantProp>`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-rows: 1fr;
  grid-template-columns: 1fr min-content;
  grid-template-rows: 1fr;
  gap: 3px;
  grid-template-areas: 'input side-content';
  position: relative;
  line-height: 16px;
  align-items: center;

  box-sizing: border-box;

  border-style: solid;
  border-color: ${({ theme, variant }) => theme.Input.variants[variant].borderColor};
  border-top-width: ${({ theme, variant }) => theme.Input.variants[variant].border.top};
  border-left-width: ${({ theme, variant }) => theme.Input.variants[variant].border.left};
  border-right-width: ${({ theme, variant }) => theme.Input.variants[variant].border.right};
  border-bottom-width: ${({ theme, variant }) => theme.Input.variants[variant].border.bottom};
  background-color: ${({ theme, variant }) => theme.Input.variants[variant].backgroundColor};

  padding-top: ${({ theme, variant }) => theme.Input.variants[variant].padding.top};
  padding-left: ${({ theme, variant }) => theme.Input.variants[variant].padding.left};
  padding-right: ${({ theme, variant }) => theme.Input.variants[variant].padding.right};
  padding-bottom: ${({ theme, variant }) => theme.Input.variants[variant].padding.bottom};

  width: calc(100% - 22px);
  border-radius: ${({ theme, variant }) => theme.Input.variants[variant].borderRadius};

  input {
    color: ${({ theme, variant }) => theme.Input.variants[variant].color};
    background-color: ${({ theme, variant }) => theme.Input.variants[variant].backgroundColor};
  }

  &.error {
    border-color: ${({ theme }) => theme.Input.state.error.borderColor};
  }

  &.success {
    border-color: ${({ theme }) => theme.Input.state.success.borderColor};
  }
`;

export const InputWrapper = styled.input`
  grid-area: input;
  outline: none;
  border: none;
  appearance: none;
  padding: 0;
  line-height: 20px;
  width: 100%;

  ::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #bfbfbf;
  }
`;

export const InputButtonClear = styled.button`
  grid-area: side-content;
  padding: 0;
  margin: 0;
  width: min-content;
  background-color: transparent;
  border: none;

  cursor: pointer;

  display: ${({ theme }) => (theme.Input.withCleanButton ? 'flex' : 'none')};
  align-items: center;
`;

export const InputHelper = styled.div<IVariantProp>`
  color: ${({ theme, variant }) => theme.Input.variants[variant].color};
  font-size: 12px;

  &.error {
    color: ${({ theme }) => theme.Input.state.error.color};
  }
`;
export const InputErrorText = styled.div`
  font-size: ${({ theme }) => theme.Input.state.error.fontSize};
  line-height: ${({ theme }) => theme.Input.state.error.lineHeight};
  font-weight: 400;
  color: ${({ theme }) => theme.Input.state.error.color};
`;

export const IconContainer = styled.div`
  grid-area: side-content;
  position: absolute;
  display: contents;
  right: 0;
`;
